var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6663 8.50219C14.6663 12.1841 11.6812 15.1693 7.99926 15.1693C4.31897 15.1651 1.33635 12.1825 1.33301 8.50219C1.33301 4.82106 4.3173 1.83594 7.99926 1.83594C11.6812 1.83594 14.6663 4.82106 14.6663 8.50219ZM2.44377 8.50219C2.44377 11.5708 4.93068 14.0585 7.99926 14.0585C11.0662 14.0552 13.5514 11.5691 13.5547 8.50219C13.5547 5.43444 11.0678 2.9467 7.99926 2.9467C4.93068 2.9467 2.44377 5.43444 2.44377 8.50219ZM9.28047 9.4344L8.20308 10.5118C7.93186 10.783 7.93186 11.2228 8.20308 11.4932C8.47431 11.7644 8.91411 11.7644 9.1845 11.4932L11.6848 8.99377C11.8149 8.86358 11.8884 8.68666 11.8884 8.50223C11.8884 8.31863 11.8149 8.14171 11.6848 8.01153L9.1845 5.5121C8.91411 5.24088 8.47431 5.24088 8.20308 5.5121C7.93186 5.78249 7.93186 6.22229 8.20308 6.49351L9.28047 7.57089C9.31969 7.61095 9.33137 7.6702 9.30967 7.72194C9.28881 7.77368 9.23791 7.8079 9.18199 7.8079H4.80487C4.42182 7.8079 4.11053 8.11918 4.11053 8.50223C4.11053 8.88612 4.42182 9.19656 4.80487 9.19656H9.18199C9.23791 9.19656 9.28965 9.23078 9.31051 9.28252C9.33221 9.33426 9.32052 9.39435 9.28047 9.4344Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircle);
export default __webpack_public_path__ + "static/media/RightCircle.67709a59698346f74d72d07a7b4ebd91.svg";
export { ForwardRef as ReactComponent };